'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInvalidDomainError = exports.getBookInfoErrorText = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reselect = require('reselect');

var _errors = require('MeetingsLib/constants/errors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNetworkErrors = (0, _get2.default)('networkErrors');

var getBookInfoErrorText = exports.getBookInfoErrorText = (0, _reselect.createSelector)([getNetworkErrors], function (networkErrors) {
  var bookInfoError = (0, _get2.default)('publicAvailabilityInfoFetch', networkErrors);
  if (bookInfoError && bookInfoError.xhr) {
    return bookInfoError.xhr.responseText;
  }
  return null;
});

var isInvalidDomainError = exports.isInvalidDomainError = (0, _reselect.createSelector)([getBookInfoErrorText], function (bookInfoErrorText) {
  if (bookInfoErrorText) {
    return bookInfoErrorText.indexOf(_errors.INVALID_DOMAIN_FOR_LINK) > -1;
  }
  return false;
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/NetworkErrorSelector.js
// module id = 502
// module chunks = 0